import uuid from "uuid/v4";

import {
  IDSK,
  AuthorizationContextInput,
  CreateRoleInput,
  CreateRolePolicyInput,
  ModelRolePolicyConnection,
  Resource,
  Role,
  RolePolicy,
  UpdateRolePolicyInput,
  UpdateWorkspaceInput,
} from "@examspark/types";

import { GraphQLAPI } from "../client";
import { role } from "../queries";

import {
  deleteResource,
  getResource,
  listResourcesByWorkspaceId,
} from "./resource";

/* List roles */
const refetchRoles = (variables: any) => {
  // return gqlQuery<{ listWorkspaceRoles: any }>({
  //   query: queries.listRoles,
  //   variables,
  // });
};

const refetchRole = (variables: any) => {
  // return gqlQuery({
  //   query: queries.getRole,
  //   variables,
  // });
};

/** Creates a new `role` inside a workspace */
export const createRole = async (data: {
  input: Omit<CreateRoleInput, "id" | "sk">;
  authorizationContext: any;
}) => {
  const id = uuid();
  return GraphQLAPI.client.query<{ createRole: Role }>({
    query: role.createRoleSecure,
    variables: {
      input: {
        ...data.input,
        id,
        sk: "role",
      },
      authorizationContext: data.authorizationContext,
    },
  });
};

export const listRoles = async (workspaceId: string) => {
  return listResourcesByWorkspaceId({
    fields: `items { id sk name description }`,
    variables: {
      workspaceId: workspaceId,
      sk: {
        eq: "role",
      },
    },
  });
};

export const getRole = (id: string, sk: string) => {
  return getResource({
    label: "GetRole",
    fields: `id sk name description`,
    variables: {
      id,
      sk,
    },
  });
};

export const getRolePolicy = async (
  rolePolicyKey: IDSK,
  authorizationContext: AuthorizationContextInput,
) => {
  const result = await GraphQLAPI.client.query<{
    getRolePolicy: RolePolicy;
  }>({
    query: /* GraphQL */ `
      query GetRolePolicy(
        $input: ModelGetInput!
        $authorizationContext: AuthorizationContextInput
      ) {
        getRolePolicy(
          input: $input
          authorizationContext: $authorizationContext
        ) {
          id
          sk
          name
          description
          roleId
          policyId
          cedar {
            effect
            action
            resource
            conditions
          }
          tags {
            key
            type
            value
          }
        }
      }
    `,
    variables: {
      input: rolePolicyKey,
      authorizationContext,
    },
  });

  return result.data?.getRolePolicy;
};

export const updateRole = async (
  workspaceId: string,
  roleId: string,
  data: Partial<UpdateWorkspaceInput>,
) => {
  // return await gqlQuery({
  //   query: /* GraphQL */ `
  //     mutation UpdateWorkspace($input: UpdateWorkspaceInput!) {
  //       updateWorkspace(input: $input) {
  //         ${fragmentBasic}
  //       }
  //     }
  //   `,
  //   variables: {
  //     input: Object.assign(
  //       {
  //         id: `${workspaceId}`,
  //         sk: ["role", roleId].join("#"),
  //       },
  //       data
  //     ),
  //   },
  // });
};

/** Creates a new `role-policy` inside a workspace */
export const createRolePolicy = async (data: {
  roleId: string;
  input: Omit<CreateRolePolicyInput, "id" | "sk">;
  authorizationContext: any;
}) => {
  const rolePolicyId = uuid();
  return GraphQLAPI.client.query<{ createRole: Role }>({
    query: role.createRolePolicy,
    variables: {
      input: {
        ...data.input,
        id: data.roleId,
        sk: `role-policy#${rolePolicyId}`,
      },
      authorizationContext: data.authorizationContext,
    },
  });
};

/** Update `role-policy` inside a workspace */
export const updateRolePolicy = async (data: {
  input: UpdateRolePolicyInput;
  authorizationContext: any;
}) => {
  return GraphQLAPI.client.query<{ createRole: Role }>({
    query: role.updateRolePolicy,
    variables: {
      input: {
        ...data.input,
      },
      authorizationContext: data.authorizationContext,
    },
  });
};

export const listRolePolicies = async (
  roleId: string,
  authorizationContext: any,
) => {
  const result = await GraphQLAPI.client.query<{
    listRolePolicies: ModelRolePolicyConnection;
  }>({
    query: /* GraphQL */ `
      query ListRolePolicies(
        $input: ListRolePoliciesInput
        $authorizationContext: AuthorizationContextInput
      ) {
        listRolePolicies(
          input: $input
          authorizationContext: $authorizationContext
        ) {
          items {
            id
            sk
            name
            description
            workspaceId
            createdAt
            creatorId
            roleId
            policyId
            cedar {
              effect
              action
              resource
              conditions
            }
            tags {
              key
              type
              value
            }
          }
        }
      }
    `,
    variables: {
      input: {
        id: roleId,
      },
      authorizationContext,
    },
  });

  return result.data?.listRolePolicies;
};

export const deleteRolePolicy = async (key: Partial<Resource>) => {
  return deleteResource(key);
};
